import RelationshipMetadata from "../../RelationshipMetadata";

class ETLJobExecutionETLJobSystemExecutionLogRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "ETLJobExecutionETLJobSystemExecutionLog";
        this.parentEnterpriseComponent = "ETLJobExecution";
        this.childEnterpriseComponent = "ETLJobSystemExecutionLog";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "ETLJobExecutionUSID";
    }
}

export default ETLJobExecutionETLJobSystemExecutionLogRelationshipMetadata;